__webpack_require__.p = "/weather-wise/";